import {useRef} from "react";
import CardView from "../../components/Views/CardView";
import {useTheme} from "@mui/material/styles";
import {Box, Button, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import PopupData from "./PopupData";

export const PropCard = ({obj, editHandler = null, deleteHandler = null}) => {
    const theme = useTheme()


    return <Box className='white-card' sx={{width: '100%'}}>
        <Stack spacing={2} marginBottom={3}>
            <Typography color={theme.palette.primary.main} variant='headline2'>{obj?.title}</Typography>
            <Stack direction='row' spacing={2} alignItems='center'>
                <div dangerouslySetInnerHTML={{__html: obj?.content}} />
                <img height='40px' width='40px' src={obj?.image} alt={obj?.name}/>
            </Stack>
        </Stack>
        <Stack spacing={2} direction='row'>
            <Button startIcon={<EditRoundedIcon/>} variant="contained" onClick={editHandler}>Szerkesztés</Button>
            <Button startIcon={<DeleteForeverRoundedIcon/>} variant="outlined" onClick={deleteHandler}>Törlés</Button>
        </Stack>
    </Box>
}

const Popups = () => {
    const popupForm = useRef(null)
    return <CardView
        title='Popup'
        pluralTitle='Popupok'
        baseSlug='admin-popups'
        formRef={popupForm}
        form={<PopupData reference={popupForm}/>}
        PropCard={PropCard}
        isImageInForm
    />
}

export default Popups;